import Image, { ImageProps } from 'next/image';

import { MediaContainer } from './LineItemView.styles';

function Media({ css, className, ...props }: ImageProps): JSX.Element {
  return (
    <MediaContainer css={css} className={className}>
      {props.src && <Image {...props} unoptimized />}
    </MediaContainer>
  );
}

Media.defaultProps = {
  layout: 'fill',
  objectFit: 'contain',
  unoptimized: true,
};

export default Media;
